import { financeRoutes } from '@/Finance/finance.routes';
const financeModule = {
    routes: financeRoutes
};
export default financeModule;
